/** UI copy for Digital Friendo — Deutsch + English */
export const SUPPORTED = [
  { code: 'de', label: 'Deutsch', flag: 'DE' },
  { code: 'en', label: 'English', flag: 'GB' },
];

export const strings = {
  de: {
    brand: 'Digital Friendo',
    brandDomain: 'digitalfriendo.com',
    nav: {
      home: 'Start',
      platform: 'Plattform',
      capabilities: 'Funktionen',
      journey: 'Ablauf',
      reasons: 'Warum wir',
      faq: 'FAQ',
      contact: 'Kontakt',
    },
    headerCta: 'Zugang sichern',
    hero: {
      badge: 'Dein digitaler Begleiter',
      titleA: 'KI, die sich',
      titleB: 'anfühlt wie ein Freund.',
      lead:
        'Digital Friendo ist dein persönliches KI-Studio im Browser: Ideen entwickeln, Texte verfeinern, Aufgaben strukturieren und den digitalen Alltag entspannter meistern.',
      ctaPrimary: 'Jetzt loslegen',
      ctaSecondary: 'Plattform entdecken',
      legal:
        'Kostenpflichtiges wöchentliches Abonnement. Bezahlung über Mobile Billing (Mobilfunkrechnung). Mit Abschluss akzeptieren Sie unsere AGB. Kündigung jederzeit möglich. Support: support@digitalfriendo.com. Anbieter: Niffo Mobile B.V.',
      bento: [
        { label: 'Aktive Nutzer', value: '12.400+' },
        { label: 'Durchschnittliche Zeitersparnis', value: '3,2 Std.' },
        { label: 'Verfügbarkeit', value: '24/7' },
      ],
      chip: 'Wöchentliches Abo',
    },
    stats: {
      items: [
        { value: '98%', label: 'Zufriedenheit', sub: 'bei wiederkehrenden Nutzern' },
        { value: '< 30s', label: 'Startzeit', sub: 'von Registrierung bis erstem Ergebnis' },
        { value: 'DE + EN', label: 'Sprachen', sub: 'Oberfläche und Inhalte' },
        { value: '100%', label: 'Browserbasiert', sub: 'keine Installation nötig' },
      ],
    },
    platform: {
      kicker: 'Die Plattform',
      title: 'Ein ruhiger Ort',
      titleAccent: 'für produktives Denken.',
      body:
        'Kein überladenes Dashboard, kein Technik-Chaos. Digital Friendo bündelt Assistenten, Vorlagen und Workflows in einer klaren Oberfläche, die sich an deinen Rhythmus anpasst.',
      highlight: 'Ob am Schreibtisch, unterwegs oder abends auf dem Sofa: dein Friendo ist immer erreichbar.',
      devicesTitle: 'Geräteübergreifend',
      devicesSub: 'Desktop, Tablet und Smartphone im selben Konto.',
    },
    capabilities: {
      kicker: 'Was drinsteckt',
      title: 'Werkzeuge, die',
      titleAccent: 'wirklich helfen.',
      items: [
        {
          title: 'Gedanken sortieren',
          description: 'Unstrukturierte Notizen in klare Pläne, Listen und nächste Schritte verwandeln.',
          tag: 'Organisation',
        },
        {
          title: 'Texte verfeinern',
          description: 'Entwürfe überarbeiten, Tonalität anpassen und Inhalte in Sekunden schärfen.',
          tag: 'Schreiben',
        },
        {
          title: 'Ideen entfachen',
          description: 'Brainstorming-Impulse, Varianten und frische Perspektiven auf Knopfdruck.',
          tag: 'Kreativität',
        },
        {
          title: 'Abläufe vereinfachen',
          description: 'Wiederkehrende digitale Schritte bündeln und mit smarten Vorschlägen beschleunigen.',
          tag: 'Automatisierung',
        },
        {
          title: 'Persönlich einstellen',
          description: 'Stil, Sprache und Fokus so wählen, dass Ergebnisse zu dir passen.',
          tag: 'Individualität',
        },
        {
          title: 'Alles griffbereit',
          description: 'Ergebnisse speichern, wiederfinden und bei Bedarf weitergeben.',
          tag: 'Bibliothek',
        },
      ],
    },
    journey: {
      kicker: 'In vier Schritten',
      title: 'So startest du',
      titleAccent: 'mit Friendo.',
      intro: 'Kein Setup-Marathon. Registrieren, einrichten, nutzen, fertig.',
      steps: [
        {
          num: '01',
          title: 'Konto anlegen',
          description: 'E-Mail und Passwort eingeben. In unter einer Minute bist du drin.',
        },
        {
          num: '02',
          title: 'Profil feinjustieren',
          description: 'Sprache, Schwerpunkte und bevorzugten Stil festlegen.',
        },
        {
          num: '03',
          title: 'Erste Aufgabe wählen',
          description: 'Text, Plan oder Idee: Friendo führt dich Schritt für Schritt.',
        },
        {
          num: '04',
          title: 'Ergebnisse sichern',
          description: 'Alles bleibt in deinem Bereich, jederzeit abrufbar.',
        },
      ],
    },
    reasons: {
      kicker: 'Warum Friendo',
      title: 'Weniger Reibung.',
      titleAccent: 'Mehr Flow.',
      intro: 'Digital Friendo ersetzt keine Menschen, aber es nimmt dir die kleinen digitalen Hürden ab, die den Tag ausbremsen.',
      quote: 'Endlich fühlt sich KI nicht nach Bedienungsanleitung an.',
      quoteSub: 'Freundlich, direkt und auf den Punkt: genau so, wie digitale Hilfe sein sollte.',
      bullets: [
        'Klare Oberfläche statt Feature-Wirrwarr.',
        'Antworten, die zu deinem Ton passen.',
        'Schneller Einstieg ohne technisches Vorwissen.',
      ],
      cta: 'Friendo testen',
      panelTitle: 'Dein Studio',
      panelKicker: 'ALLES AN EINEM ORT',
      panelBody: 'Assistent, Vorlagen und gespeicherte Arbeit in einer übersichtlichen Umgebung.',
      panelSub: 'Weniger Tab-Wechsel, mehr Fortschritt bei dem, was zählt.',
      imageAlt: 'Person arbeitet entspannt am Laptop',
      panelAlt: 'Übersichtliche digitale Arbeitsumgebung',
    },
    cta: {
      badge: 'Bereit für deinen Friendo?',
      title: 'Starte heute',
      titleSub: 'mit Digital Friendo.',
      body: 'Schalte den vollen Zugang frei: persönliche KI-Werkzeuge, Vorlagen und smarte Workflows in einer Plattform.',
      perks: [
        'Voller Plattform-Zugang',
        'Persönliche Einstellungen',
        'Jederzeit kündbar',
        'Alle modernen Browser',
      ],
      button: 'Zugang sichern',
      priceLine: 'Wöchentliches Abonnement, Bezahlung über Mobile Billing.',
      helpLine: 'Support: support@digitalfriendo.com',
      legalBox:
        'Digital Friendo ist ein kostenpflichtiger KI-Service. Mit Abschluss des Abonnements akzeptieren Sie unsere AGB. Das Abonnement verlängert sich automatisch, sofern es nicht gekündigt wird. Bezahlung über Mobile Billing (Mobilfunkrechnung). Anbieter: Niffo Mobile B.V., Stationsplein 28, 1382 AD Weesp, Niederlande.',
    },
    faq: {
      kicker: 'FAQ',
      title: 'Gut zu',
      titleAccent: 'wissen.',
      intro: 'Kurze Antworten auf die häufigsten Fragen zu Digital Friendo.',
      items: [
        {
          q: 'Was ist Digital Friendo?',
          a: 'Digital Friendo ist ein browserbasierter KI-Service mit persönlichen Assistenten, Vorlagen und Workflows für Schreiben, Planen und kreatives Arbeiten.',
        },
        {
          q: 'Wie melde ich mich an?',
          a: 'Klicke auf „Zugang sichern", trage E-Mail und Passwort ein und du kannst sofort loslegen.',
        },
        {
          q: 'Was kostet der Service?',
          a: 'Digital Friendo wird als wöchentliches Abonnement angeboten. Die Bezahlung erfolgt über Mobile Billing (Mobilfunkrechnung).',
        },
        {
          q: 'Kann ich jederzeit kündigen?',
          a: 'Ja. Die Kündigung wird zum Ende der laufenden Abrechnungsperiode wirksam.',
        },
        {
          q: 'Auf welchen Geräten funktioniert es?',
          a: 'Auf aktuellen Browsern wie Chrome, Safari, Firefox und Edge sowie auf Smartphones und Tablets.',
        },
        {
          q: 'Brauche ich eine App?',
          a: 'Nein. Digital Friendo läuft vollständig im Browser, ohne Download oder Installation.',
        },
      ],
      contactTitle: 'Noch etwas offen?',
      contactLead: 'Schreib uns eine Nachricht, wir antworten schnell.',
      email: 'support@digitalfriendo.com',
    },
    footer: {
      blurb:
        'Digital Friendo, dein freundlicher KI-Begleiter für klares Denken und produktives Arbeiten. Anbieter: Niffo Mobile B.V.',
      legalShort:
        'Kostenpflichtiges wöchentliches Abo. Kündigung jederzeit möglich. Details zu Abrechnung und Widerruf in den AGB.',
      navTitle: 'Navigation',
      contactTitle: 'Kontakt',
      cta: 'Zugang sichern',
      copyright: 'Digital Friendo. Niffo Mobile B.V. Alle Rechte vorbehalten.',
      agb: 'AGB',
      privacy: 'Datenschutz',
      help: 'Hilfe',
      imprint: 'Impressum',
      widerruf: 'Widerruf',
    },
  },
  en: {
    brand: 'Digital Friendo',
    brandDomain: 'digitalfriendo.com',
    nav: {
      home: 'Home',
      platform: 'Platform',
      capabilities: 'Features',
      journey: 'How it works',
      reasons: 'Why Friendo',
      faq: 'FAQ',
      contact: 'Contact',
    },
    headerCta: 'Get access',
    hero: {
      badge: 'Your digital companion',
      titleA: 'AI that feels',
      titleB: 'like a friend.',
      lead:
        'Digital Friendo is your personal AI studio in the browser: develop ideas, refine copy, structure tasks, and handle digital life with less friction.',
      ctaPrimary: 'Get started',
      ctaSecondary: 'Explore the platform',
      legal:
        'Paid weekly subscription. Payment via mobile billing. By subscribing you accept our terms. Cancel anytime. Support: support@digitalfriendo.com. Provider: Niffo Mobile B.V.',
      bento: [
        { label: 'Active users', value: '12,400+' },
        { label: 'Average time saved', value: '3.2 hrs' },
        { label: 'Availability', value: '24/7' },
      ],
      chip: 'Weekly subscription',
    },
    stats: {
      items: [
        { value: '98%', label: 'Satisfaction', sub: 'among returning users' },
        { value: '< 30s', label: 'Time to start', sub: 'from sign-up to first result' },
        { value: 'DE + EN', label: 'Languages', sub: 'interface and content' },
        { value: '100%', label: 'Browser-based', sub: 'no installation required' },
      ],
    },
    platform: {
      kicker: 'The platform',
      title: 'A calm space',
      titleAccent: 'for focused work.',
      body:
        'No cluttered dashboards, no tech overwhelm. Digital Friendo brings assistants, templates, and workflows into one clear interface that adapts to your rhythm.',
      highlight: 'At your desk, on the go, or on the sofa at night: your Friendo is always within reach.',
      devicesTitle: 'Cross-device',
      devicesSub: 'Desktop, tablet, and phone under one account.',
    },
    capabilities: {
      kicker: 'Inside the box',
      title: 'Tools that',
      titleAccent: 'actually help.',
      items: [
        {
          title: 'Sort your thoughts',
          description: 'Turn messy notes into clear plans, lists, and next steps.',
          tag: 'Organisation',
        },
        {
          title: 'Polish your writing',
          description: 'Revise drafts, adjust tone, and sharpen content in seconds.',
          tag: 'Writing',
        },
        {
          title: 'Spark ideas',
          description: 'Brainstorming prompts, variations, and fresh angles on demand.',
          tag: 'Creativity',
        },
        {
          title: 'Simplify routines',
          description: 'Bundle recurring digital steps and speed them up with smart suggestions.',
          tag: 'Automation',
        },
        {
          title: 'Make it yours',
          description: 'Choose style, language, and focus so results feel personal.',
          tag: 'Personalisation',
        },
        {
          title: 'Keep it handy',
          description: 'Save results, find them again, and share when you need to.',
          tag: 'Library',
        },
      ],
    },
    journey: {
      kicker: 'In four steps',
      title: 'How you start',
      titleAccent: 'with Friendo.',
      intro: 'No setup marathon. Register, configure, use, done.',
      steps: [
        {
          num: '01',
          title: 'Create your account',
          description: 'Enter email and password. You are in within a minute.',
        },
        {
          num: '02',
          title: 'Fine-tune your profile',
          description: 'Set language, focus areas, and preferred style.',
        },
        {
          num: '03',
          title: 'Pick your first task',
          description: 'Text, plan, or idea: Friendo guides you step by step.',
        },
        {
          num: '04',
          title: 'Save your results',
          description: 'Everything stays in your space, ready whenever you need it.',
        },
      ],
    },
    reasons: {
      kicker: 'Why Friendo',
      title: 'Less friction.',
      titleAccent: 'More flow.',
      intro: 'Digital Friendo does not replace people, but it clears the small digital hurdles that slow your day down.',
      quote: 'Finally, AI that does not feel like a manual.',
      quoteSub: 'Friendly, direct, and to the point: exactly how digital help should feel.',
      bullets: [
        'Clear interface instead of feature clutter.',
        'Responses that match your tone.',
        'Fast start with no technical background needed.',
      ],
      cta: 'Try Friendo',
      panelTitle: 'Your studio',
      panelKicker: 'ALL IN ONE PLACE',
      panelBody: 'Assistant, templates, and saved work in one tidy environment.',
      panelSub: 'Fewer tab switches, more progress on what matters.',
      imageAlt: 'Person working calmly on a laptop',
      panelAlt: 'Clean digital workspace overview',
    },
    cta: {
      badge: 'Ready for your Friendo?',
      title: 'Start today',
      titleSub: 'with Digital Friendo.',
      body: 'Unlock full access: personal AI tools, templates, and smart workflows in one platform.',
      perks: [
        'Full platform access',
        'Personal settings',
        'Cancel anytime',
        'All modern browsers',
      ],
      button: 'Get access',
      priceLine: 'Weekly subscription, payment via mobile billing.',
      helpLine: 'Support: support@digitalfriendo.com',
      legalBox:
        'Digital Friendo is a paid AI service. By subscribing you accept our terms. The subscription renews automatically unless cancelled. Payment via mobile billing. Provider: Niffo Mobile B.V., Stationsplein 28, 1382 AD Weesp, Netherlands.',
    },
    faq: {
      kicker: 'FAQ',
      title: 'Good to',
      titleAccent: 'know.',
      intro: 'Short answers to the most common questions about Digital Friendo.',
      items: [
        {
          q: 'What is Digital Friendo?',
          a: 'Digital Friendo is a browser-based AI service with personal assistants, templates, and workflows for writing, planning, and creative work.',
        },
        {
          q: 'How do I sign up?',
          a: 'Click "Get access", enter your email and password, and you can start right away.',
        },
        {
          q: 'What does it cost?',
          a: 'Digital Friendo is offered as a weekly subscription. Payment is via mobile billing.',
        },
        {
          q: 'Can I cancel anytime?',
          a: 'Yes. Cancellation takes effect at the end of the current billing period.',
        },
        {
          q: 'Which devices are supported?',
          a: 'Current browsers including Chrome, Safari, Firefox, and Edge, plus smartphones and tablets.',
        },
        {
          q: 'Do I need an app?',
          a: 'No. Digital Friendo runs entirely in the browser with no download or installation.',
        },
      ],
      contactTitle: 'Still unsure?',
      contactLead: 'Send us a message, we reply quickly.',
      email: 'support@digitalfriendo.com',
    },
    footer: {
      blurb:
        'Digital Friendo, your friendly AI companion for clear thinking and productive work. Provider: Niffo Mobile B.V.',
      legalShort:
        'Paid weekly subscription. Cancel anytime. See terms for billing and withdrawal details.',
      navTitle: 'Navigate',
      contactTitle: 'Contact',
      cta: 'Get access',
      copyright: 'Digital Friendo. Niffo Mobile B.V. All rights reserved.',
      agb: 'Terms',
      privacy: 'Privacy',
      help: 'Help',
      imprint: 'Imprint',
      widerruf: 'Withdrawal',
    },
  },
};
